import React from "react";
import { createRoot } from "react-dom/client";
import ahoy from "ahoy.js";
import Trix from "trix";

import FlashToaster, {
  FLASH_EVENT_NAME,
} from "@/components/v6/base/flash_toaster";

window.Trix = Trix;

const initialFlashes = () => (
  Array.from(document.querySelectorAll("[data-oomple-flash]")).map((element) => ({
    type: element.dataset.oompleFlashType || "notice",
    message: element.textContent.trim() || "Success!",
  }))
);

const ensureFlashToaster = () => {
  let container = document.getElementById("oomple-flash-toaster");

  if (!container) {
    container = document.createElement("div");
    container.id = "oomple-flash-toaster";
    document.body.appendChild(container);
  }

  if (!container._oompleRoot) {
    const flashes = initialFlashes();

    document.querySelectorAll("[data-oomple-flash]").forEach((element) => {
      element.remove();
    });

    container._oompleRoot = createRoot(container);
    container._oompleRoot.render(
      <FlashToaster initialToasts={flashes} />
    );
  }
};

window.flash = (type, message) => {
  window.dispatchEvent(
    new CustomEvent(FLASH_EVENT_NAME, {
      detail: {
        type,
        message,
      },
    })
  );
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", ensureFlashToaster, {
    once: true,
  });
} else {
  ensureFlashToaster();
}

ahoy.trackView();
ahoy.trackClicks("a, button, input[type=submit]");
ahoy.trackSubmits("form");
ahoy.trackChanges("input, textarea, select");
